import React from 'react';
import { createRoot } from 'react-dom/client';
import { Exchange } from './Exchange';
import providerHOC from '../utils/providerHOC/providerHOC';

const ExchangeWrapper = providerHOC()(Exchange);
createRoot(document.getElementById('exchange')).render(<ExchangeWrapper />);
